function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.017 34.3559L19.9304 34.3517M136.881 124.423C136.878 122.487 137.099 119.763 138.893 114.521C140.878 108.721 145.991 104.962 150.754 102.048C150.66 102.755 150.532 103.34 150.403 103.882C150.178 104.823 149.949 105.798 150.257 106.876C150.55 107.904 151.483 108.693 152.56 109.607C153.568 110.465 154.701 111.429 155.276 112.614C155.72 113.528 155.899 114.693 155.755 115.746C154.022 113.207 151.237 113.006 150.417 113.006C146.567 113.006 143.492 115.253 141.275 119.681C140.02 122.187 138.194 123.766 136.881 124.423ZM72.2902 124.43C70.9843 123.762 69.1645 122.176 67.913 119.681C65.6965 115.253 62.6225 113.006 58.7704 113.006C57.952 113.006 55.167 113.207 53.4324 115.746C53.2899 114.693 53.4687 113.528 53.9114 112.614C54.4882 111.429 55.6279 110.461 56.6293 109.607C57.709 108.693 58.6391 107.904 58.9324 106.876C59.2397 105.798 59.0107 104.823 58.7858 103.882C58.6713 103.387 58.5246 102.779 58.4283 102.037C63.1755 104.944 68.3069 108.707 70.2944 114.521C72.0821 119.731 72.3112 122.459 72.2902 124.43ZM86.3491 166.898C85.3547 166.559 84.4245 166.372 83.5097 166.326L83.5488 165.366C83.5627 156.943 83.5809 147.394 81.3686 142.309C80.585 140.517 79.3937 138.734 78.2428 137.013C76.233 134.01 74.1562 130.911 74.1562 127.665C74.1562 127.126 74.1813 126.612 74.2064 126.058C74.328 123.498 74.4634 120.598 72.1645 113.881C69.7832 106.936 63.6588 102.84 58.1056 99.5486C57.438 97.8622 57.7956 95.5021 59.0246 93.5563C60.5261 91.1851 63.0149 89.8279 65.8543 89.8279C75.6576 89.8279 82.8337 99.723 89.1662 108.453C94.4833 115.789 99.077 122.123 104.594 122.123C110.111 122.123 114.706 115.789 120.023 108.451C126.355 99.723 133.53 89.8279 143.339 89.8279C146.174 89.8279 148.662 91.1851 150.164 93.5563C151.398 95.5021 151.751 97.8622 151.065 99.5695C145.53 102.84 139.406 106.936 137.027 113.881C134.724 120.598 134.861 123.515 134.983 126.087C135.008 126.612 135.033 127.129 135.033 127.665C135.033 130.908 132.959 134.007 130.953 137.002C129.798 138.731 128.604 140.513 127.82 142.309C125.607 147.394 125.625 156.946 125.64 165.373V166.369C124.76 166.372 123.834 166.559 122.844 166.898C124.195 160.47 122.075 156.399 119.365 155.213C117.023 154.189 114.816 153.221 113.007 148.922C112.471 147.65 112.118 145.808 111.738 143.859C110.748 138.731 109.622 132.914 104.594 132.914C99.5672 132.914 98.4415 138.727 97.4498 143.852C97.0713 145.808 96.718 147.654 96.1845 148.922C94.3716 153.221 92.1662 154.189 89.8282 155.21C87.1173 156.396 84.9971 160.47 86.3491 166.898ZM56.343 128.615C54.491 127.573 52.4742 125.012 52.7927 121.198C53.7368 124.316 56.2927 126.34 59.8333 126.769C60.2621 126.818 60.6909 126.847 61.1127 126.847C63.4688 126.847 65.1895 126.03 66.5722 125.376C67.5206 124.929 68.3027 124.579 69.0751 124.497C70.0835 125.476 71.1924 126.186 72.2427 126.536C72.2008 126.879 72.1827 127.264 72.1827 127.665C72.1827 131.503 74.4243 134.852 76.5947 138.095C77.7568 139.835 78.8476 141.463 79.5585 143.095C81.6074 147.801 81.5892 157.135 81.5795 165.369L81.5753 166.49C77.8392 167.134 76.1199 170.456 76.1199 173.254C76.1199 174.284 76.2442 176.889 76.3629 179.408L76.3838 179.843C76.4369 180.996 76.4914 182.106 76.5375 183.131C75.6799 181.916 74.6534 180.567 73.5919 179.178C69.8083 174.218 65.1001 168.051 63.7663 162.938C63.2007 160.77 61.3277 147.212 61.1266 144.258C60.9562 141.723 59.8151 136.049 57.8193 131.325L56.343 128.615ZM151.375 131.307C149.374 136.042 148.233 141.723 148.061 144.262C147.861 147.212 145.987 160.77 145.423 162.938C144.089 168.051 139.381 174.221 135.597 179.177C134.467 180.658 133.463 181.985 132.619 183.177C132.702 182.029 132.762 180.721 132.826 179.4C132.948 176.867 133.069 174.278 133.069 173.254C133.069 170.456 131.353 167.134 127.577 166.447L127.614 165.362C127.598 157.131 127.582 147.801 129.629 143.095C130.341 141.458 131.432 139.831 132.587 138.107C134.76 134.859 137.006 131.503 137.006 127.665C137.006 127.264 136.988 126.875 136.974 126.49C137.999 126.179 139.104 125.472 140.145 124.483C140.885 124.579 141.636 124.911 142.615 125.376C143.999 126.03 145.723 126.847 148.076 126.847C148.487 126.847 148.916 126.818 149.356 126.769C152.917 126.337 155.477 124.284 156.403 121.123C156.75 124.961 154.719 127.561 152.846 128.615L151.462 131.286L151.375 131.307ZM92.4484 191.987C90.8687 191.987 88.9511 190.769 87.4427 188.81C86.3309 187.359 85.641 185.759 85.4943 184.293C87.6466 185.964 90.1564 187.353 92.2263 188.016C93.6285 188.465 94.3325 189.345 94.1607 190.435C94.0392 191.206 93.4135 191.987 92.4484 191.987ZM116.741 191.987C115.774 191.987 115.148 191.206 115.027 190.433C114.857 189.345 115.563 188.465 116.961 188.016C119.033 187.353 121.542 185.964 123.695 184.293C123.548 185.759 122.858 187.359 121.746 188.81C120.241 190.769 118.32 191.987 116.741 191.987ZM88.3435 205.666C84.3281 205.666 78.6367 195.102 78.6367 187.079C78.6367 185.617 78.4858 182.508 78.3434 179.502L78.3364 179.308C78.2107 176.698 78.0934 174.232 78.0934 173.254C78.0934 171.534 79.1367 168.28 83.0837 168.28C86.1801 168.28 89.338 170.477 92.6802 172.804C96.4135 175.399 100.271 178.083 104.594 178.083C108.921 178.083 112.778 175.397 116.512 172.799C119.851 170.476 123.008 168.28 126.104 168.28C130.055 168.28 131.1 171.534 131.1 173.254C131.1 174.232 130.974 176.8 130.857 179.283L130.846 179.498C130.702 182.505 130.557 185.615 130.557 187.079C130.557 195.102 124.949 205.664 120.935 205.664C103.965 198.292 88.3435 205.666 88.3435 205.666ZM104.594 211.535C96.9037 211.535 94.257 210.159 92.1872 209.022L92.2375 209.007C95.6844 207.888 99.5812 206.622 104.594 206.622C109.606 206.622 113.505 207.888 116.945 209.006L117.002 209.022C114.931 210.159 112.285 211.535 104.594 211.535Z",
  stroke: "url(#paint0_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.836 97.6313C51.836 97.6313 49.8922 100.982 38.9726 100.712C28.0585 100.445 22.1253 104.612 18.6235 108.377C15.119 112.145 9.99678 118.197 12.4241 119.674C14.8514 121.153 13.3668 119.002 19.4304 121.691C25.4953 124.383 34.2579 122.363 38.4347 119.136C42.6143 115.91 46.8496 104.431 56.9963 106.004C56.9963 106.004 55.5456 103.026 55.9531 100.928C55.9531 100.928 52.4337 99.6644 51.836 97.6313Z",
  stroke: "url(#paint1_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.3806 105.804C53.3806 105.804 35.5388 100.847 27.7957 104.246C20.0485 107.645 15.1852 113.696 14.5063 120.231",
  stroke: "url(#paint2_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M158.089 96.7273C158.089 96.7273 160.071 100.195 171.209 99.9156C182.343 99.639 188.394 103.955 191.965 107.858C195.54 111.758 200.765 118.026 198.289 119.557C195.817 121.091 197.329 118.86 191.142 121.648C184.956 124.434 176.018 122.342 171.759 118.999C167.496 115.658 163.175 103.768 152.825 105.397C152.825 105.397 154.305 102.312 153.889 100.139C153.889 100.139 157.483 98.8304 158.089 96.7273Z",
  stroke: "url(#paint3_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M156.442 105.803C156.442 105.803 174.282 100.848 182.025 104.246C189.77 107.644 194.635 113.699 195.316 120.231",
  stroke: "url(#paint4_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54.7654 5.48631C54.7654 5.48631 56.022 7.60749 59.2527 6.82073",
  stroke: "url(#paint5_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M51.8635 8.21055C51.8635 8.21055 53.761 11.3381 57.9953 10.4513",
  stroke: "url(#paint6_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4915 10.949C48.4915 10.949 51.9111 15.4221 56.3845 14.5464",
  stroke: "url(#paint7_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M45.1753 13.4321C45.1753 13.4321 47.5454 18.3736 53.0781 18.7698",
  stroke: "url(#paint8_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M41.2239 16.001C41.2239 16.001 43.4967 22.1282 49.8204 22.3284",
  stroke: "url(#paint9_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7224 18.1057C37.7224 18.1057 38.3341 25.2824 46.0423 25.5785",
  stroke: "url(#paint10_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M33.51 20.5714C33.51 20.5714 34.5416 27.6308 41.7911 28.6738",
  stroke: "url(#paint11_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M29.9514 22.706C29.9514 22.706 30.9145 30.5777 38.2825 31.6481",
  stroke: "url(#paint12_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0366 24.4854C26.0366 24.4854 27.033 34.0463 35.2892 34.0933",
  stroke: "url(#paint13_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1221 26.977C22.1221 26.977 23.8982 36.9407 32.7982 36.9407",
  stroke: "url(#paint14_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M4.83423 63.9969C4.83423 63.9969 19.5898 66.4059 30.3066 52.5979",
  stroke: "url(#paint15_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M9.47803 70.2651C9.47803 70.2651 26.3679 70.0085 32.7985 55.4447",
  stroke: "url(#paint16_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6484 75.371C14.6484 75.371 30.9133 75.0803 35.5921 57.9984",
  stroke: "url(#paint17_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9871 79.6429C19.9871 79.6429 35.3719 77.7422 39.5599 60.783",
  stroke: "url(#paint18_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7485 83.9113C26.7485 83.9113 40.8574 80.6215 43.8303 62.5604",
  stroke: "url(#paint19_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M33.1541 87.4698C33.1541 87.4698 46.6501 80.9562 47.2291 63.5892",
  stroke: "url(#paint20_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5608 90.6722C39.5608 90.6722 51.8019 81.7775 51.2089 64.7802",
  stroke: "url(#paint21_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M2.12354 57.1959C2.12354 57.1959 19.9031 60.9962 29.1696 49.901",
  stroke: "url(#paint22_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M2.27124 48.3811C2.27124 48.3811 16.2544 56.8936 29.0185 47.7764",
  stroke: "url(#paint23_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M6.10938 40.8538C6.10938 40.8538 16.4521 50.3289 29.2409 45.335",
  stroke: "url(#paint24_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M9.76294 36.1926C9.76294 36.1926 17.3029 46.0789 29.5955 43.6769",
  stroke: "url(#paint25_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8884 32.6687C13.8884 32.6687 19.4815 42.2769 30.3077 41.1108",
  stroke: "url(#paint26_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0558 65.323C54.0558 65.323 44.1221 64.1076 39.6882 61.4535C31.1075 56.3127 24.8976 49.8979 31.2311 38.8699C37.5646 27.839 59.925 22.4554 58.7602 0.000187203C58.7602 0.000187203 53.075 9.98029 30.0677 22.3229C7.06035 34.6654 -5.34988 48.0615 6.28291 66.4449C14.7991 79.901 34.47 89.1318 44.3995 93.1116C44.3995 93.1116 56.2535 80.4369 54.0558 65.323Z",
  stroke: "url(#paint27_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0558 65.323C54.0558 65.323 44.1221 64.1076 39.6882 61.4535C31.1075 56.3127 24.8976 49.8979 31.2311 38.8699C37.5646 27.839 59.925 22.4554 58.7602 0.000187203C58.7602 0.000187203 53.075 9.98029 30.0677 22.3229C7.06035 34.6654 -5.34988 48.0615 6.28291 66.4449C14.7991 79.901 34.47 89.1318 44.3995 93.1116C44.3995 93.1116 56.2535 80.4369 54.0558 65.323Z",
  stroke: "url(#paint28_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M154.746 5.48643C154.746 5.48643 153.489 7.60761 150.257 6.82086",
  stroke: "url(#paint29_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M157.645 8.21055C157.645 8.21055 155.747 11.3381 151.513 10.4513",
  stroke: "url(#paint30_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M161.017 10.949C161.017 10.949 157.598 15.4221 153.12 14.5464",
  stroke: "url(#paint31_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M164.336 13.4321C164.336 13.4321 161.966 18.3736 156.432 18.7698",
  stroke: "url(#paint32_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M168.289 16.001C168.289 16.001 166.015 22.1282 159.691 22.3284",
  stroke: "url(#paint33_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M171.782 18.1058C171.782 18.1058 171.174 25.2825 163.465 25.5786",
  stroke: "url(#paint34_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M175.858 20.5715C175.858 20.5715 174.838 27.7024 167.673 28.756",
  stroke: "url(#paint35_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M179.416 22.3492C179.416 22.3492 178.469 30.5341 171.227 31.6471",
  stroke: "url(#paint36_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M183.69 24.8409C183.69 24.8409 182.655 34.0477 174.081 34.0929",
  stroke: "url(#paint37_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M187.956 27.3317C187.956 27.3317 186.063 36.9396 176.568 36.9396",
  stroke: "url(#paint38_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M204.328 64.1771C204.328 64.1771 189.689 66.6242 179.062 52.5979",
  stroke: "url(#paint39_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M200.031 70.2648C200.031 70.2648 183.038 70.0143 176.568 55.8001",
  stroke: "url(#paint40_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M195.787 74.6613C195.787 74.6613 178.803 74.3825 173.915 58.0004",
  stroke: "url(#paint41_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M189.024 79.9987C189.024 79.9987 173.922 78.0621 169.807 60.7829",
  stroke: "url(#paint42_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M182.265 84.267C182.265 84.267 169.041 80.9224 166.25 62.5603",
  stroke: "url(#paint43_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M176.213 87.4698C176.213 87.4698 162.855 80.9562 162.282 63.5892",
  stroke: "url(#paint44_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M169.808 90.6732C169.808 90.6732 157.716 81.7493 158.303 64.6964",
  stroke: "url(#paint45_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M207.173 57.0145C207.173 57.0145 189.396 60.4282 180.127 50.4618",
  stroke: "url(#paint46_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M207.239 48.3811C207.239 48.3811 193.258 56.8936 180.492 47.7764",
  stroke: "url(#paint47_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M203.616 41.211C203.616 41.211 193.272 50.118 180.484 45.4235",
  stroke: "url(#paint48_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M199.344 36.2283C199.344 36.2283 192.039 45.627 180.127 43.3434",
  stroke: "url(#paint49_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M194.007 31.6014C194.007 31.6014 188.795 41.61 178.704 40.3953",
  stroke: "url(#paint50_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M164.747 93.1116C174.835 89.1318 194.817 79.901 203.469 66.4449C215.285 48.0615 202.679 34.6654 179.307 22.3229C155.935 9.98029 150.158 0.000187203 150.158 0.000187203C148.976 22.4554 171.691 27.839 178.124 38.8699C184.558 49.8979 178.25 56.3099 169.534 61.4535C165.029 64.1076 154.937 65.323 154.937 65.323C152.705 80.4369 164.747 93.1116 164.747 93.1116Z",
  stroke: "url(#paint51_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M164.747 93.1116C174.835 89.1318 194.817 79.901 203.469 66.4449C215.285 48.0615 202.679 34.6654 179.307 22.3229C155.935 9.98029 150.158 0.000187203 150.158 0.000187203C148.976 22.4554 171.691 27.839 178.124 38.8699C184.558 49.8979 178.25 56.3099 169.534 61.4535C165.029 64.1076 154.937 65.323 154.937 65.323C152.705 80.4369 164.747 93.1116 164.747 93.1116Z",
  stroke: "url(#paint52_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M67.8447 122.336C67.8447 122.336 64.265 115.357 59.4691 115.725C55.2269 116.05 54.7211 118.884 55.484 121.003C56.3188 123.331 61.9539 127.373 67.8447 122.336Z",
  stroke: "url(#paint53_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M65.1328 121.495C65.1328 121.495 62.8315 117.309 59.7512 117.527C57.0195 117.722 56.6961 119.425 57.1872 120.695C57.7214 122.092 61.3462 124.515 65.1328 121.495Z",
  stroke: "url(#paint54_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M63.3237 120.411C63.3237 120.411 62.0461 118.318 60.3348 118.427C58.8176 118.525 58.637 119.376 58.9087 120.012C59.2075 120.711 61.2209 121.921 63.3237 120.411Z",
  stroke: "url(#paint55_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M141.977 122.336C141.977 122.336 145.557 115.357 150.351 115.725C154.596 116.05 155.099 118.884 154.339 121.003C153.504 123.331 147.871 127.373 141.977 122.336Z",
  stroke: "url(#paint56_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M144.688 121.495C144.688 121.495 146.735 117.309 149.476 117.527C151.901 117.722 152.187 119.425 151.752 120.695C151.276 122.092 148.058 124.515 144.688 121.495Z",
  stroke: "url(#paint57_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M147.4 120.411C147.4 120.411 148.423 118.318 149.792 118.427C151.008 118.525 151.149 119.376 150.931 120.012C150.693 120.711 149.083 121.921 147.4 120.411Z",
  stroke: "url(#paint58_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M52.4753 96.8973L54.3947 96.7257C52.6398 91.7672 53.8887 88.4565 55.2296 86.3317C56.8646 83.7464 59.5756 82.2634 62.6658 82.2634C73.3455 82.2634 81.1636 93.0647 88.0618 102.594C93.8561 110.605 98.8586 117.519 104.868 117.519C110.876 117.519 115.883 110.605 121.675 102.594C128.571 93.0647 136.39 82.2634 147.069 82.2634C150.164 82.2634 152.872 83.7464 154.505 86.3317C155.848 88.4565 157.085 92.9852 155.47 97.0256L158.249 96.5178",
  stroke: "url(#paint59_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M55.188 86.522C55.238 85.1987 55.6892 83.7703 56.5041 82.5056C58.0811 80.054 60.7008 78.6474 63.6855 78.6474C74.0031 78.6474 81.5594 88.8945 88.2231 97.9355C93.8205 105.532 98.6572 112.095 104.46 112.095C110.267 112.095 115.101 105.532 120.699 97.9355C127.362 88.8945 134.919 78.6474 145.235 78.6474C148.221 78.6474 150.839 80.054 152.422 82.5056C153.231 83.7675 153.68 85.1959 153.73 86.5193",
  stroke: "url(#paint60_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9963 81.335C57.1199 80.1787 57.5393 78.966 58.2295 77.884C59.7544 75.4957 62.2791 74.1275 65.1621 74.1275C75.1123 74.1275 82.4004 84.0976 88.8289 92.8923C94.2296 100.286 98.893 106.671 104.492 106.671C110.092 106.671 114.756 100.286 120.157 92.8923C126.584 84.0976 133.872 74.1275 143.827 74.1275C146.707 74.1275 149.23 75.4957 150.757 77.884C151.525 79.0857 151.862 80.0589 151.922 81.3267",
  stroke: "url(#paint61_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M58.8035 77.0314C58.957 76.0303 59.3465 74.9939 59.9536 74.0581C61.4193 71.8019 63.8481 70.5115 66.6216 70.5115C76.1985 70.5115 83.2084 79.9287 89.3906 88.2347C94.586 95.2178 99.075 101.247 104.463 101.247C109.852 101.247 114.34 95.2178 119.535 88.2347C125.717 79.9287 132.729 70.5115 142.306 70.5115C145.078 70.5115 147.508 71.8019 148.974 74.0581C149.574 74.9804 149.959 76.0018 150.113 76.9974",
  stroke: "url(#paint62_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5161 71.7913C61.7062 71.2589 61.9661 70.7318 62.2889 70.2345C63.6767 68.113 65.9812 66.8954 68.603 66.8954C77.6729 66.8954 84.3125 75.7588 90.1696 83.5775C95.0916 90.1463 99.3429 95.8232 104.444 95.8232C109.546 95.8232 113.796 90.1463 118.72 83.5775C124.575 75.7588 131.212 66.8954 140.285 66.8954C142.908 66.8954 145.212 68.113 146.6 70.2345C146.94 70.7562 147.208 71.3102 147.401 71.8737",
  stroke: "url(#paint63_linear)",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 2.69156,
  y1: 163.236,
  x2: 178.143,
  y2: 135.395,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 6.08547,
  y1: 116.043,
  x2: 58.5476,
  y2: 96.7473,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 9.59727,
  y1: 115.549,
  x2: 51.6751,
  y2: 95.9347,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 147.003,
  y1: 115.797,
  x2: 200.707,
  y2: 96.3438,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 151.533,
  y1: 115.549,
  x2: 193.611,
  y2: 95.9347,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 54.1987,
  y1: 6.58427,
  x2: 58.499,
  y2: 3.95123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 51.0892,
  y1: 9.95565,
  x2: 57.4154,
  y2: 6.62543,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 47.4947,
  y1: 13.6484,
  x2: 56.2203,
  y2: 9.82611,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 44.1773,
  y1: 17.3148,
  x2: 53.7043,
  y2: 14.4096,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 40.1383,
  y1: 20.6036,
  x2: 50.6426,
  y2: 17.6643,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 36.6718,
  y1: 23.5415,
  x2: 47.0865,
  y2: 21.1533,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 32.4643,
  y1: 26.4652,
  x2: 42.9125,
  y2: 24.2658,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 28.8994,
  y1: 29.2105,
  x2: 39.4867,
  y2: 27.179,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 24.8682,
  y1: 31.4742,
  x2: 36.5981,
  y2: 29.1477,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 20.7739,
  y1: 34.2246,
  x2: 34.1875,
  y2: 31.2645,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 1.61755,
  y1: 61.0069,
  x2: 29.4483,
  y2: 48.3767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 6.53309,
  y1: 66.2252,
  x2: 34.3398,
  y2: 57.2135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 12.0037,
  y1: 70.6354,
  x2: 37.9967,
  y2: 64.1814,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 17.5154,
  y1: 74.5019,
  x2: 42.178,
  y2: 69.2304,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 24.5914,
  y1: 78.0912,
  x2: 46.5035,
  y2: 74.4806,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 31.3766,
  y1: 80.9602,
  x2: 49.6528,
  y2: 78.7416,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 38.0872,
  y1: 83.6143,
  x2: 53.331,
  y2: 82.1993,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: -1.29188,
  y1: 55.6642,
  x2: 22.5561,
  y2: 38.8974,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: -1.10643,
  y1: 50.8425,
  x2: 11.9071,
  y2: 33.8344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: 3.1883,
  y1: 45.1709,
  x2: 21.723,
  y2: 30.2923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear",
  x1: 7.25846,
  y1: 41.9104,
  x2: 27.834,
  y2: 31.2184,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear",
  x1: 11.815,
  y1: 38.881,
  x2: 30.5169,
  y2: 31.4756,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear",
  x1: -5.34349,
  y1: 67.7302,
  x2: 68.5288,
  y2: 58.4235,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear",
  x1: -5.34349,
  y1: 67.7302,
  x2: 68.5288,
  y2: 58.4235,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear",
  x1: 149.69,
  y1: 6.58439,
  x2: 153.991,
  y2: 3.95015,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear",
  x1: 150.739,
  y1: 9.95565,
  x2: 157.065,
  y2: 6.62544,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear",
  x1: 152.123,
  y1: 13.6484,
  x2: 160.852,
  y2: 9.82272,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear",
  x1: 155.433,
  y1: 17.3148,
  x2: 164.962,
  y2: 14.4087,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear",
  x1: 158.606,
  y1: 20.6036,
  x2: 169.111,
  y2: 17.6634,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear",
  x1: 162.415,
  y1: 23.5416,
  x2: 172.827,
  y2: 21.155,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear",
  x1: 166.639,
  y1: 26.525,
  x2: 176.985,
  y2: 24.394,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear",
  x1: 170.193,
  y1: 29.1126,
  x2: 180.639,
  y2: 27.2176,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear",
  x1: 172.868,
  y1: 31.5709,
  x2: 184.974,
  y2: 28.9814,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear",
  x1: 175.13,
  y1: 34.3205,
  x2: 189.291,
  y2: 30.8637,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear",
  x1: 175.871,
  y1: 61.1398,
  x2: 203.698,
  y2: 48.8082,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint40_linear",
  x1: 173.605,
  y1: 66.3218,
  x2: 201.416,
  y2: 57.0309,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear",
  x1: 171.153,
  y1: 70.1196,
  x2: 198.008,
  y2: 62.8585,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint42_linear",
  x1: 167.38,
  y1: 74.7606,
  x2: 191.67,
  y2: 69.7575,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint43_linear",
  x1: 164.228,
  y1: 78.3499,
  x2: 184.852,
  y2: 75.2161,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint44_linear",
  x1: 160.522,
  y1: 80.9602,
  x2: 178.618,
  y2: 78.786,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint45_linear",
  x1: 156.827,
  y1: 83.5921,
  x2: 171.887,
  y2: 82.2159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint46_linear",
  x1: 176.712,
  y1: 55.6387,
  x2: 198.81,
  y2: 38.3424,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint47_linear",
  x1: 177.115,
  y1: 50.8425,
  x2: 190.128,
  y2: 33.8344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint48_linear",
  x1: 177.563,
  y1: 45.2692,
  x2: 195.189,
  y2: 30.2181,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint49_linear",
  x1: 177.7,
  y1: 41.664,
  x2: 197.474,
  y2: 31.1911,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint50_linear",
  x1: 176.772,
  y1: 38.0725,
  x2: 194.686,
  y2: 31.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint51_linear",
  x1: 142.807,
  y1: 67.7302,
  x2: 217.815,
  y2: 58.1305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint52_linear",
  x1: 142.807,
  y1: 67.7302,
  x2: 217.815,
  y2: 58.1305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint53_linear",
  x1: 53.5897,
  y1: 122.287,
  x2: 68.9861,
  y2: 117.847,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint54_linear",
  x1: 55.9689,
  y1: 121.465,
  x2: 65.7554,
  y2: 118.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint55_linear",
  x1: 58.2326,
  y1: 120.396,
  x2: 63.5607,
  y2: 118.567,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint56_linear",
  x1: 140.379,
  y1: 122.287,
  x2: 155.775,
  y2: 117.847,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint57_linear",
  x1: 143.775,
  y1: 121.465,
  x2: 152.636,
  y2: 119.031,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint58_linear",
  x1: 146.943,
  y1: 120.396,
  x2: 151.374,
  y2: 119.179,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint59_linear",
  x1: 39.1181,
  y1: 107.909,
  x2: 139.977,
  y2: 45.5863,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint60_linear",
  x1: 42.744,
  y1: 102.978,
  x2: 137.643,
  y2: 45.3945,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint61_linear",
  x1: 45.0091,
  y1: 97.8001,
  x2: 136.915,
  y2: 42.5875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint62_linear",
  x1: 47.2728,
  y1: 92.869,
  x2: 134.811,
  y2: 39.308,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint63_linear",
  x1: 50.6705,
  y1: 87.9378,
  x2: 133.036,
  y2: 37.5728,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})));

function SvgTaurus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 212,
    viewBox: "0 0 209 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurus);
export default __webpack_public_path__ + "static/media/taurus.f28ec235.svg";
export { ForwardRef as ReactComponent };